import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import EloBadge from './EloBadge.js';

const EloChange = ({ value, result, currentElo }) => {
  const isPositive = value >= 0;
  const displayValue = isPositive ? `+${value}` : value;
  const color = result === 'Win' ? '#4CAF50' : '#F44336';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
      }}
    >
      {/* Current ELO badge */}
      <EloBadge value={currentElo} size="small" />

      {/* ELO Change */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.25rem',
          color: color,
          fontWeight: 700,
          fontSize: '0.95rem',
        }}
      >
        {isPositive ? (
          <TrendingUpIcon sx={{ fontSize: '1.1rem' }} />
        ) : (
          <TrendingDownIcon sx={{ fontSize: '1.1rem' }} />
        )}
        <span>{displayValue}</span>
      </Box>
    </Box>
  );
};

EloChange.propTypes = {
  value: PropTypes.number.isRequired,
  result: PropTypes.string.isRequired,
  currentElo: PropTypes.number.isRequired,
};

export default EloChange;
